import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OtpWebChallengeData } from '../../interfaces';
import { FormBuilder, Validators } from '@angular/forms';
import { OtpService } from '../../services/otp.service';

@Component({
  selector: 'bn-otp-web',
  templateUrl: './banesco-otp-web.component.html',
})
export class BanescoOTPWebComponent implements OnInit {
  @Output() continue = new EventEmitter<{ action: string; method: string }>();
  @Output() cancel = new EventEmitter<{ action: string }>();
  @Input() data!: OtpWebChallengeData;
  readonly form = this.fb.group({ method: [null, [Validators.required]] });

  constructor(private readonly fb: FormBuilder) {}

  ngOnInit() {}

  onCancel() {
    this.cancel.emit({ action: 'cancel' });
  }

  onSelect() {
    if (this.form.valid) {
      OtpService.currentOtpMethod = { action: 'send', method: this.form.value.method };
      this.continue.emit({ action: 'send', method: this.form.value.method });
    }
  }
}
